import React from 'react';
import { Checkbox, Tooltip } from 'antd';

// Reusable Tenant Checkbox Group component
const TenantCheckboxGroup = ({
  tenants, selectedValues, onChange, allSelected, disabled
}) => {
  // Function to get tenant list with tooltips
  const getTenantList = () => tenants?.data?.map((tenant) => ({
    label: (
      <Tooltip title={tenant?.tenant_name}>
        {tenant?.tenant_name}
      </Tooltip>
    ),
    value: tenant?.tenant_id,
  })) || [];

  return (
    <Checkbox.Group
      options={getTenantList()}
      onChange={onChange}
      value={selectedValues}
      disabled={disabled}
    />
  );
};

export default TenantCheckboxGroup;
